import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'gea-hrt-image-preview-thumbnail-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="image-preview-dialog">
      @let imageData = config.data?.imageData;
      @if (imageData) {
        <div class="image-container">
          <img [src]="imageData" alt="Image preview" class="preview-image" />
        </div>
      } @else {
        <div class="empty-state">No image available</div>
      }
    </div>
  `,
  styles: `
    .image-preview-dialog {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      border-radius: 14px;
      background: linear-gradient(145deg, #f7f9fc, #eef2f9);
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
      min-height: 220px;
    }

    .image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-height: 70vh;
      overflow: hidden;
      border-radius: 10px;
      background: #fff;
      padding: 0.5rem;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
    }

    .preview-image {
      max-width: 100%;
      max-height: 68vh;
      object-fit: contain;
      border-radius: 8px;
      display: block;
    }

    .empty-state {
      color: #6b7280;
      font-size: 0.95rem;
      text-align: center;
    }
  `,
})
export class ThumbnailDialogComponent {
  readonly config = inject(DynamicDialogConfig<{ imageData: string }>);
}
